import Vue from 'vue'
import VueRouter from 'vue-router'

import control from '../components/control.vue'
import deviceList from '../components/DeviceList.vue'
import channelList from '../components/channelList.vue'
import pushVideoList from '../components/PushVideoList.vue'
import streamProxyList from '../components/StreamProxyList.vue'
import devicePosition from  '../components/devicePosition.vue'
import login from '../components/Login.vue'
import parentPlatformList from '../components/ParentPlatformList.vue'
import cloudRecord from '../components/CloudRecord.vue'
import test from '../components/test.vue'
import web from '../components/setting/Web.vue'
import sip from '../components/setting/Sip.vue'
import media from '../components/setting/Media.vue'

import wasmPlayer from '../components/dialog/jessibuca.vue'
import rtcPlayer from '../components/dialog/rtcPlayer.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)


 const router = new VueRouter({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: '首页',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/solve',
      name: '智慧解决方案',
      component: () => import('../views/Solve.vue')
    },
    {
      path: '/aboutUs',
      name: '关于我们',
      component: () => import('../views/aboutUs.vue')
    },
    {
      path: '/increment',
      name: '增值业务中心',
      component: () => import('../views/increment.vue')
    },
    
    {
      path: '/agentRecruitment',
      name: '事业家招募',
      component: () => import('../views/agentRecruitment.vue')
    },
    {
      path: '/newsCenter',
      name: '新闻中心',
      component: () => import('../views/newsCenter.vue')
    },
    {
      path: '/corporateNews',
      name: '企业资讯',
      component: () => import('../views/corporateNews.vue')
    },
    {
      path: '/industryInformation',
      name: '行业资讯',
      component: () => import('../views/industryInformation.vue')
    },
    {
      path: '/corporateNewsDetail',
      name: '企业资讯详情',
      component: () => import('../views/corporateNewsDetail.vue')
    },
    {
      path: '/industryInformationDetail',
      name: '行业资讯详情',
      component: () => import('../views/industryInformationDetail.vue')
    },
    {
      path: '/productCenter',
      name: '产品中心',
      component: () => import('../views/productCenter.vue')
    },
    {
        path: '/successCase',
        name: '成功案例',
        component: () => import('../views/SuccessCase.vue')
    },
    {
        path: '/caseInfo',
        name: '案例详情',
        component: () => import('../views/CaseInfo.vue')
    },
    {
        path: '/contactUs',
        name: '联系我们',
        component: () => import('../views/ContactUs.vue')
    },
    {
      path: '/xmkList',
      name: '项目库',
      component: () => import('../views/xmkList.vue')
    },
    
    // {
    //   path: '/',
    //   component: control,
    // },
    {
      path: '/deviceList',
      component: deviceList,
    },
    {
      path: '/pushVideoList',
      component: pushVideoList,
    },
    {
      path: '/streamProxyList',
      component: streamProxyList,
    },
    {
      path: '/login',
      name: '登录',
      component: login,
    },
    {
      path: '/channelList/:deviceId/:parentChannelId/:count/:page',
      name: 'channelList',
      component: channelList,
    },
    {
      path: '/parentPlatformList/:count/:page',
      name: 'parentPlatformList',
      component: parentPlatformList,
    },
    {
      path: '/devicePosition/:deviceId/:parentChannelId/:count/:page',
      name: 'devicePosition',
      component: devicePosition,
    },
    {
      path: '/cloudRecord',
      name: 'cloudRecord',
      component: cloudRecord,
    },
    {
      path: '/setting/web',
      name: 'web',
      component: web,
    },
    {
      path: '/setting/sip',
      name: 'sip',
      component: sip,
    },
    {
      path: '/setting/media',
      name: 'media',
      component: media,
    },
    {
      path: '/test',
      name: 'test',
      component: test,
    },
    {
      path: '/play/wasm/:url',
      name: 'wasmPlayer',
      component: wasmPlayer,
    },
    {
      path: '/play/rtc/:url',
      name: 'rtcPlayer',
      component: rtcPlayer,
    },
  ],
  /* scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0}
    } */
})

router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0;
  next();
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js